import config from '../../config';
const host = config.host;
export const apilists = {
    getUserInfos: {
          url: config.host + '/user/info',
          method: 'get'
    },
    checkLoginStatus: {
        url: config.host + '/checkLoginStatus',
        method: 'get',
    },
    getUserStoreTemp: {
        url: config.host + '/resume/getUserStoreTemp',
        method: 'post',
    },
    saveResumePDF2Server: {
        url: config.host + '/resume/upload-resume',
        method: 'post',
    },
    createResumeV2: {
        url: config.host + '/resumeV2/create',
        method: 'post',
    },
    getResumeV2List: {
        url: config.host + '/resumeV2/getList',
        method: 'post',
    },
    updateResumeV2: {
        url: config.host + '/resumeV2/update',
        method: 'post',
    },
    deleteResumeV2: {
        url: config.host + '/resumeV2/delete',
        method: 'post',
    },
    aiCreateResume: {
        url: config.host + '/resume/aiCreateResume',
        method: 'post',
    },
    updateUserStoreTemplate: {
        url: config.host + '/resume/updateUserStoreTemplate',
        method: 'post',
    },
    aiOptimizeText: {
        url: config.host + '/resume/aiOptimizeText',
        method: 'post',
    },
    resumeDownload: {
        url: config.host + '/resume/download',
        method: 'post',
    },
}